import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box } from '@mui/material'
import BannerSlideELibrary from '../element/BannerSlide'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom'
import BooksCart from '../element/BooksCart'
import BookSlide from '../element/BooksViewList'
import { useDispatch, useSelector } from 'react-redux'
import { ELibraryFrontApi, listData } from '../../../../api/e-library/e_library_front.api'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { RootState } from '../../../../store/store'
import Hashids from 'hashids'
import { ELibraryCategory, LIBRARY_HEAD_STATUS, LIBRARY_LIKE } from '../../enum/elibrary_enum'
import { globalLikeBookmark } from '../element/global_like_func'

type Props = {}

const Journal: React.FC<Props> = (props: Props) => {
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();


    const dispatch = useDispatch();
    const base_api = useSelector((state: RootState) => state.api.image_api);
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);


    const [all_data, set_all_data] = useState<any[]>([]);
    const [news_data, set_news_data] = useState<any[]>([]);
    const [popular_data, set_popular_data] = useState<any[]>([]);
    const [loading_like, set_loading_like] = useState<boolean>(false);

    const handleGetData = async (library_category_name: string, mode?: "NEW" | "POPULAR", isPending?: boolean) => {
        let query: listData = {
            page: 1, limit: 10, library_category_name,
        }
        if (mode) query.library_head_status = mode;
        if (!isPending) {
            dispatch(setLoading());
        }
        await ELibraryFrontApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                if (mode === 'NEW') {
                    set_news_data(response);
                } else if (mode === 'POPULAR') {
                    set_popular_data(response)
                } else {
                    set_all_data(response)
                }
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
            set_loading_like(false);
        })
    }


    useEffect(() => {
        handleGetData(ELibraryCategory.MAGAZINE, 'NEW')
        handleGetData(ELibraryCategory.MAGAZINE, 'POPULAR')
        handleGetData(ELibraryCategory.MAGAZINE)
    }, [])

    return (
        <ContainerLayout
            title='วารสาร'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: 'A',
                            name: "วารสาร",
                            pathName: pathname
                        },
                    ]}
                />
            }
            buttonContent={
                <BooksCart />
            }
            content={
                <Box>
                    <BannerSlideELibrary />

                    <BookSlide
                        title="วารสาร มาใหม่"
                        subtitle="วารสาร มาใหม่จาก IBSC กรุณาเลือกรายการที่ต้องการ"
                        onViewAll={() => navigate({ pathname: routeName.e_library.journal_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.NEW }).toString() })}
                        disabled_check={loading_like}
                        data={news_data?.map((list) => {
                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                            return {
                                onClick: (id) => {
                                    const encode_id = hash_ids.encode(String(id || ""));
                                    navigate({ pathname: routeName.e_library.journal_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.NEW }).toString() })
                                },
                                checkedLike: !!list?.is_like,
                                checkedBookmark: !!list?.is_bookmark,
                                setCheckedBookmark: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.BOOKMARK);
                                    handleGetData(ELibraryCategory.MAGAZINE, 'NEW', true);
                                },
                                setCheckedLike: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.LIKE);
                                    handleGetData(ELibraryCategory.MAGAZINE, 'NEW', true);
                                },
                                book_name: list?.library_head_name || "",
                                book_sub_name: list?.library_author_by || "",
                                id: list?.id_library_head,
                                img_url: img_url
                            }
                        })}
                    />
                    <BookSlide
                        title="วารสาร ยอดนิยม"
                        subtitle="วารสาร ยอดนิยมจาก IBSC กรุณาเลือกรายการที่ต้องการ"
                        onViewAll={() => navigate({ pathname: routeName.e_library.journal_list, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })}
                        data={popular_data?.map((list) => {
                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                            return {
                                onClick: (id) => {
                                    const encode_id = hash_ids.encode(String(id || ""));
                                    navigate({ pathname: routeName.e_library.journal_detail.replace(":id", encode_id), search: createSearchParams({ status: LIBRARY_HEAD_STATUS.POPULAR }).toString() })
                                },
                                checkedLike: !!list?.is_like,
                                checkedBookmark: !!list?.is_bookmark,
                                setCheckedBookmark: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.BOOKMARK);
                                    handleGetData(ELibraryCategory.MAGAZINE, 'POPULAR', true);
                                },
                                setCheckedLike: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.LIKE);
                                    handleGetData(ELibraryCategory.MAGAZINE, 'POPULAR', true);
                                },
                                book_name: list?.library_head_name || "",
                                book_sub_name: list?.library_author_by || "",
                                id: list?.id_library_head,
                                img_url: img_url
                            }
                        })}
                    />
                    <BookSlide
                        title="วารสาร ทั้งหมด"
                        subtitle="วารสาร ทั้งหมดจาก IBSC กรุณาเลือกรายการที่ต้องการ"
                        onViewAll={() => navigate({ pathname: routeName.e_library.journal_list, search: createSearchParams({ status: "ALL" }).toString() })}
                        data={all_data?.map((list) => {
                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                            return {
                                onClick: (id) => {
                                    const encode_id = hash_ids.encode(String(id || ""));
                                    navigate({ pathname: routeName.e_library.journal_detail.replace(":id", encode_id), search: createSearchParams({ status: "ALL" }).toString() })
                                },
                                checkedLike: !!list?.is_like,
                                checkedBookmark: !!list?.is_bookmark,
                                setCheckedBookmark: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.BOOKMARK);
                                    handleGetData(ELibraryCategory.MAGAZINE, undefined, true);
                                },
                                setCheckedLike: async () => {
                                    set_loading_like(true);
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.LIKE);
                                    handleGetData(ELibraryCategory.MAGAZINE, undefined, true);
                                },
                                book_name: list?.library_head_name || "",
                                book_sub_name: list?.library_author_by || "",
                                id: list?.id_library_head,
                                img_url: img_url
                            }
                        })}
                    />
                </Box>
            }
        />
    )
}

export default Journal